import { FieldErrors } from 'react-hook-form';
import { themeObject } from '../../../../lib';

export const attributesComponentStyles = {
    fieldStyles: {
        mt: 2,
        width: '100%',
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    attributesListMainContainerStyles: {
        mt: '12px',
        overflowY: 'auto',
    },
    attributesListContainerStyles: {
        border: `1px solid ${themeObject.palette.grayScale[300]}`,
        p: '8px 17px 8px 8px',
        borderRadius: '2px',
        minHeight: '162px',
        overflowY: 'auto',
        maxHeight: '100%',
    },
    attributesListEmptyContainerStyles: {
        p: '16px 8px',
    },
    attributesListEmptyContainerTextStyles: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.regular,
        lineHeight: '21.17px',
        textAlign: 'center',
    },
    attributesSelectedListContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        '& [role=button]': {
            '& .MuiGrid-root': {
                '& .MuiGrid-root': {
                    p: 0,
                    '& .MuiFormControlLabel-root': {
                        width: '100%',
                    },
                    '& .MuiTypography-root': {
                        width: '250px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    },
                },
            },
        },
    },
    attributesDraggableListContainerStyles: {
        width: '100%',
    },
    attributesUnselectedListContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        '& .MuiFormControlLabel-root': {
            '& .MuiTypography-root': {
                width: '250px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
        },
    },
    searchIconStyles: {
        color: `${themeObject.palette.primary[400]} !important`,
        width: '24px !important',
        height: '24px !important',
    },
    crossIconStyles: {
        cursor: 'pointer',
        '& .MuiSvgIcon-root': {
            height: '14px',
            width: '14px',
            color: themeObject.palette.grayScale.A200,
        },
    },
};

export const getAttributesContainerHeight = (
    errors: FieldErrors<any>
): string => {
    if (errors?.name && errors?.attributes) {
        return 'calc(100vh - 482px)';
    } else if (
        (!errors?.name && errors?.attributes) ||
        (errors?.name && !errors?.attributes)
    ) {
        return 'calc(100vh - 456px)';
    } else {
        return 'calc(100vh - 430px)';
    }
};
